import { render, staticRenderFns } from "./ib-form-entry.vue?vue&type=template&id=4442b262&lang=pug&"
import script from "./ib-form-entry.vue?vue&type=script&lang=js&"
export * from "./ib-form-entry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4442b262')) {
      api.createRecord('4442b262', component.options)
    } else {
      api.reload('4442b262', component.options)
    }
    module.hot.accept("./ib-form-entry.vue?vue&type=template&id=4442b262&lang=pug&", function () {
      api.rerender('4442b262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/ib-form-entry.vue"
export default component.exports